export default function IconGmail(props: { size?: number }) {
  const { size = 24 } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fill="#4285f4" d="M1.64 20.5h3.82v-9.27L0 7.14v11.72c0 .9.73 1.64 1.64 1.64z" />
      <path fill="#34a853" d="M18.55 20.5h3.82c.9 0 1.63-.73 1.63-1.64V7.14l-5.45 4.09" />
      <path fill="#fbbc04" d="M18.55 4.14v7.09L24 7.14V4.96c0-2.02-2.31-3.17-3.93-1.96" />
      <path fill="#ea4335" d="M5.45 11.23V4.14L12 9.05l6.55-4.91v7.09L12 16.14" />
      <path fill="#c5221f" d="M0 4.96v2.18l5.45 4.09V4.14L3.93 3C2.31 1.79 0 2.94 0 4.96" />
    </svg>
  );
}
